module.exports = __webpack_public_path__ + "img/img_index_banner_x3@2x.e0e7dcd1.png";